var jQuery = require('jquery');
var _ = require('lodash');

var InputField = function(options) {
  var fieldLabel = jQuery('<div class="form-elm-label">' + options.label + '</div>');
  this.$fieldContainer = jQuery('<div class="form-elm text-input top-align">');
  this.$fieldAndWarningLabelContainer = jQuery('<div class="input-warning-label-container">');
  this.$inputField = jQuery('<input placeholder="' + (options.placeholder || '') +  '" class="form-elm-input-text">');

  this.$fieldAndWarningLabelContainer.append(this.$inputField);

  if (! _.isEmpty(options.warningLabel)) {
    this.$fieldAndWarningLabelContainer.append(
      jQuery('<span class="click-action-note">' + options.warningLabel + '</span>')
    );
  }

  this.$inputField.blur(options.changeHandler);

  this.$inputField.keypress(function(e) {
    if(e.which === 13) {
      options.changeHandler(e);
    }
  });

  this.$inputField.focus(function(e) {
    window.editor.keyController.requestFocus(e.target);
  });

  this.inputField = this.$inputField[0];
  this.inputContainer = this.$fieldContainer.append([fieldLabel, this.$fieldAndWarningLabelContainer])[0];
  this.fieldLabel = fieldLabel[0];
};

InputField.prototype = {
  show: function() {
    this.$fieldContainer.show();
  },

  hide: function() {
    this.$fieldContainer.hide();
  },

  setValue: function(newValue) {
    this.$inputField.val(newValue);
  },
};

module.exports = InputField;



// WEBPACK FOOTER //
// ./src/ui/properties-panel/input-field.js